import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ContentService, ContextService, RatingService } from '@app/core/services';
import { ChangableComponent } from '@app/models/changable.component';
import { Content, ContentTypeEnum, EContentPaneFormat, IContentPopularityParams, IContentStats } from 'lingo2-models';
import { takeUntil } from 'rxjs';
import {ErrorNotificationService} from "@shared/error-notification/error-notification.service";

type TContentCardMiniType = 'lesson' | 'video' | 'audio' | 'image' | 'article' | 'vocabulary';

const types: { [key: number]: TContentCardMiniType } = {
  [ContentTypeEnum.video]: 'video',
  [ContentTypeEnum.audio]: 'audio',
  [ContentTypeEnum.image]: 'image',
  [ContentTypeEnum.article]: 'article',
  [ContentTypeEnum.news]: 'article',
  [ContentTypeEnum.theory]: 'article',
  [ContentTypeEnum.vocabulary]: 'vocabulary',
};

@Component({
  selector: 'app-content-card-mini',
  templateUrl: './content-card-mini.component.html',
  styleUrls: ['./content-card-mini.component.scss'],
})
export class ContentCardMiniComponent extends ChangableComponent {
  public constructor(
    public errorNotificationService: ErrorNotificationService,
    private readonly ratingService: RatingService,
    private readonly contextService: ContextService,
    private readonly contentService: ContentService,
    protected readonly cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  @Input()
  public set item(item: Content) {
    this._item = item;
    this.prepareItem();
  }

  public get item(): Content {
    return this._item;
  }

  @Input() public active: boolean;
  @Input() public linkEnable = false;
  @Input() public format: EContentPaneFormat;
  @Input() public infinity: boolean;

  public contentType: TContentCardMiniType;
  // #region for debug
  public debug$ = this.contextService.debug$;
  public debugPopularity: number;
  public debugPopularityByPeriod: number;
  public debugParams: IContentPopularityParams;
  public debugStats: Partial<IContentStats>;
  // #endregion

  private _item: Content;

  protected prepareItem() {
    this.contentService.change$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (res) => {
        if (res && res.id === this._item.id) {
          this._item.stats = { ...this._item.stats, ...res.stats };
          this.detectChanges();
        }
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
      }
    });
    this.contentType = this._item.type in types ? types[this._item.type] : 'lesson';
    this.debug$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (debug) => {
        if (debug) {
          this.reloadRating();
        }
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
      }
    });
  }

  public reloadRating() {
    this.ratingService
      .getContentRating(this._item.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (data) => {
          this.debugPopularity = data.popularity;
          this.debugPopularityByPeriod = data.popularity_by_period;
          this.debugParams = data.params;
          this.debugStats = data.stats;
          this.markForCheck();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
        }
      });
  }
}
